<div>
	<mat-action-list class="container-quick" [disableRipple]="false" >
	@for (client of topResults(); track client.client_id){
		
		@if (client.client_id == null){
			<mat-list-item>
				<p matListItemLine>No Results Found</p>
			</mat-list-item>
		}
		@if (client.client_id !== null){
			<mat-list-item class="result" (click)="searchBarService.openClientDetail(client.client_id)">
				<h3 class="result" matListItemTitle>{{client.first_name}} {{client.last_name}}</h3>
				<p  class="result" matListItemLine [innerHTML]="">{{client.mobile}}&nbsp;&nbsp;  {{client.address}}&nbsp;&nbsp;  {{client.email}} </p>
			</mat-list-item>
		}
	}
	
	<!-- <mat-divider /> -->
	<!-- <mat-list-item (click)="click()">
		<mat-icon matListItemIcon>search</mat-icon>
		<h3 matListItemTitle>All search results for "{{ searchTerm() }}"</h3>
		<span matListItemMeta  >Press ENTER</span>
	</mat-list-item> -->
</mat-action-list>
</div>